module.exports = __webpack_public_path__ + "static/media/image55.ec2c7c48.jpg";